window.burgerToggle = () => {
    const burgerMenu = document.querySelector('[data-burger-menu]');
    const burgerTrigger = document.querySelector('[data-burger]');

    if (burgerMenu && burgerTrigger) {
        burgerMenu.classList.toggle('is-open');
        burgerTrigger.classList.toggle('is-open');
    }
};